/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export class CultureStore {
    public id: string;

    public code: string;

    public name: string;

    public isoCode?: string;

    constructor(data: Pick<CultureStore, 'name' | 'code' | 'isoCode'>) {
        this.id = data.code;
        this.code = data.code;
        this.name = data.name;
        this.isoCode = data.isoCode;
    }
}
